import className from 'classnames'

export const Hero = (props) => {

  return <div className={className(`generic-hero`, props.className)} style={{backgroundImage: `url(${props.imageUrl})`}}>
    <h1 className='md:text-6xl'>{props.title}</h1>
  </div>
}
